import tree from '../state';
import * as categoryService from '../services/categoryService';

export const enterCategoryAction = ({ params,location }, replace, callback ) => {
    tree.set('loading', true);
    categoryService.getCategory(location.pathname.split('/')[1]).then(category => {
        tree.set('category', category);
        tree.set('loading', false);
        callback();
    });
};


// WEBPACK FOOTER //
// ./src/actions/categoryActions.js